import { Component, OnInit, Input } from '@angular/core';
import stc from 'string-to-color';

@Component({
    selector: 'app-profile-widget',
    templateUrl: './profile-widget.component.html',
})
export class ProfileWidgetComponent implements OnInit {
    constructor() {}

    @Input() userInfo: any = {};
    @Input() mutedNext: any = undefined;
    @Input() text: any = undefined;
    @Input() type = 1;
    @Input() link = false;
    @Input() panelStyle = false;
    @Input() hover = false;

    profileLink: string = null;

    static getCustomComponentRendered(user_info) {
        const username = user_info.user || '';
        const userText = `<span class="uk-display-inlineblock tw-font-bold"> ${username} </span>`;
        const userLink = `<a class="uk-display-inlineblock tw-font-bold" href="/user/${username}"> ${username}</a>`;
        const initials = (username.length ? username.slice(0, 2) : '?').toUpperCase();
        const avatarHtml = `<span class="profile-img profile-img-letter" style="background-color:${stc(
            username || ' '
        )}">${initials}</span>`;
        return `<div class="club-profile-widget uk-clearfix">
                  ${avatarHtml}
                  <div class="club-profile-widget-content">
                     <div class="club-profile-widget-header">
                        ${!user_info.profile_public ? userText : userLink}
                     </div>
                  </div>
               </div>`;
    }

    ngOnInit() {
        this.profileLink = this.link ? '/user/' + this.userInfo.user : null;
    }
}
